<div [formGroup]="filterGroup">
  <div class="header">
    <span>Filter by</span>
    <inline-svg src="small_close.svg" (click)="closeMenu.emit()"
      matTooltip="Close" class="close-icon"
      color="#A5B5BD"
    hoverColor="#7F8F98"></inline-svg>
  </div>
  <div class="horizontal-separator"></div>
  <div class="filter-block">
    <span class="filter-title">File Type</span>
    <div class="file-type">
      @for (type of types; track type; let i = $index) {
        <div class="file-type-item">
          <mat-checkbox
            [checked]="isSelected(type)"
            (change)="select(type)" [matTooltip]="type">
          </mat-checkbox>
          <div>{{ type }}</div>
        </div>
      }
    </div>
  </div>

  <div class="filter-block">
    <span class="filter-title">Date</span>
    <mat-form-field>
      <mat-date-range-input formGroupName="date" [rangePicker]="picker" (click)="picker.open()">
        <input matStartDate formControlName="from" placeholder="Start date" >
        <input matEndDate formControlName="to" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
      <inline-svg src="Calendar.svg" class="calendar-icon" color="#A5B5BD"
        hoverColor="#7F8F98" matIconSuffix
      (click)="picker.open()"></inline-svg>
      <mat-date-range-picker #picker>
        <mat-date-range-picker-actions>
          <button mat-button matDateRangePickerCancel (click)="clearDate()">
            <span>Clear</span>
          </button>
          <button class="frmg-primary-button" mat-button matDateRangePickerApply (click)="picker.close()">
            <span>Apply</span>
          </button>
        </mat-date-range-picker-actions>
      </mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="filter-block">
    <span class="filter-title">Ownership</span>
    <mat-form-field >
      <mat-chip-grid #chipGrid aria-label="Owners selection">
        @for (owner of addedOwners; track owner) {
          <mat-chip-row (removed)="remove(owner)">
            {{owner.email}}
            <button matChipRemove [attr.aria-label]="'remove ' + owner">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input placeholder="Owner..." #ownerInput [formControl]="ownerCtrl"
        [matChipInputFor]="chipGrid" [matAutocomplete]="auto"/>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (user of users$ | async; track user) {
            <mat-option [value]="user">
              {{user.email}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  <!--    </div>-->
  <div class="action_container">
    <button mat-raised-button class="frmg-secondary-button"
      (click)="clear()">Clear All
    </button>
    <button mat-raised-button class="frmg-primary-button"
      (click)="apply()" [disabled]="filterGroup.invalid">Apply Filter
    </button>
  </div>
</div>